import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
  cell: {
    fontSize: '1rem',
  },
});

const StatsTable = (props) => {
  const { classes, items } = props;

  const popluateRow = (item) => {
    return (
      <TableRow className={classes.row} key={item.name} >
        <TableCell className={classes.cell}> {item.name}</TableCell>
        <TableCell
          className={classes.cell}
          numeric
        >
          {Number(item.prior).toExponential(2)}
        </TableCell>
        <TableCell
          className={classes.cell}
          numeric
        >
          {Number(item.posterior).toExponential(2)}
        </TableCell>
      </TableRow>
    );
  };

  const stats = items.map(item => (popluateRow(item)));

  return (
    <div className={classes.root}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Metrics</TableCell>
            <TableCell numeric>Prior</TableCell>
            <TableCell numeric>Posterior</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {stats}
        </TableBody>
      </Table>
    </div>
  );
};

StatsTable.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    prior: PropTypes.number.isRequired,
    posterior: PropTypes.number.isRequired,
  })).isRequired,
};

export default withStyles(styles)(StatsTable);
